'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _lodash = require('lodash');

var _Chat = require('./Chat');

var _Chat2 = _interopRequireDefault(_Chat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *
 */
var mapStateToProps = function mapStateToProps(state, _ref) {
  var id = _ref.id;
  var _ref$reducer = _ref.reducer;
  var reducer = _ref$reducer === undefined ? 'vtChat' : _ref$reducer;
  return (0, _lodash.get)(state, [reducer, 'chats', id], {});
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_Chat2.default);